import { defineStore } from 'pinia';
import EjecutivoService from '@/services/ejecutivo_service';
import { Role } from '@/enum/roles_enum.js';
export const useEjecutivoStore = defineStore('ejecutivoStore', {
  state: () => ({
    ejecutivoList: [],
    page: 1,
  }),
  actions: {
    async findAllEjecutivoHTTP() {
      const result = await EjecutivoService.findActiveEjecutivos({}, 1, 300);
      if (result?.data) {
        const lista = result.data
          .map((u) => ({
            ...u,
            Descripcion: `${u.Nombre} ${u.Apellido}`,
          }))
          .filter(
            (u) =>
              u.RolUsuario === Role.EJECUTIVO_DE_VENTAS ||
              u.roles?.some?.((r) => r.Codigo === Role.EJECUTIVO_DE_VENTAS),
          );
        this.ejecutivoList = lista;
        return true;
      }
      return false;
    },
    async getEjecutivoByCodigoHTTP(codigoUsuario, RolUsuario) {
      if (!codigoUsuario) return null;
      const res = await EjecutivoService.findById(codigoUsuario, RolUsuario);
      const user = res?.data ?? null;
      if (user) {
        user.Descripcion = `${user.Nombre} ${user.Apellido}`;
      }
      return user;
    },
    async ensureEjecutivoInCache(codigoUsuario, RolUsuario) {
      if (!codigoUsuario) return null;
      const found = this.ejecutivoList.find((u) => u.Codigo === Number(codigoUsuario));
      if (found) return found;
      const user = await this.getEjecutivoByCodigoHTTP(codigoUsuario, RolUsuario);
      if (user) this.upsertEjecutivo(user);
      return user;
    },
    upsertEjecutivo(user) {
      if (!user?.Codigo) return;
      user.Descripcion = user.Descripcion || `${user.Nombre ?? ''} ${user.Apellido ?? ''}`.trim();
      const idx = this.ejecutivoList.findIndex((u) => u.Codigo === user.Codigo);
      if (idx === -1) this.ejecutivoList.push(user);
      else this.ejecutivoList[idx] = user;
    },
    async searchEjecutivosHTTP(query, RolUsuario) {
      try {
        const result = await EjecutivoService.searchByDescription(query, RolUsuario);
        if (result && result.data && result.data.length > 0) {
          return [...result.data];
        }
        return [];
      } catch (error) {
        console.error('Error al buscar ejecutivos:', error);
        throw error;
      }
    },

    async resetEjecutivoList() {
      this.setPage(1);
      this.emptyEjecutivoList();
      await this.findAllEjecutivoHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyEjecutivoList() {
      this.ejecutivoList = [];
    },
  },
});
